export class PriceRequest {
    store: string;
    sendCity: string;
    volume: number;
    willTaken: boolean;
    pallet: boolean;
    amount: number;


    constructor(store: string, sendCity: string, volume: number, willTaken: boolean,
                pallet: boolean, amount: number) {
        this.store = store;
        this.sendCity = sendCity;
        this.volume = volume;
        this.willTaken = willTaken;
        this.pallet = pallet;
        this.amount = amount;
    }
}